import './FeaturedBenefits.scss';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import useHandleAnchorClick from '../../hooks/useHandleAnchorClick';

const FeaturedBenefits = ({ data }) => {
  const columnImageUrls = [
    '/images/benefits/featured/featured_icon_1.png',
    '/images/benefits/featured/featured_icon_2.png',
    '/images/benefits/featured/featured_icon_4.png'
  ];

  const handleAnchorClick = useHandleAnchorClick();

  const columnRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [maxHeight, setMaxHeight] = useState(0);
  const [itemHeights, setItemHeights] = useState<number[]>([]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (columnRefs.current.length > 0) {
        const heights = columnRefs.current.map((el) =>
          el ? el.scrollHeight : 0
        );
        setItemHeights(heights);
        setMaxHeight(Math.max(...heights));
      }
    });

    columnRefs.current.forEach((ref) => {
      if (ref) resizeObserver.observe(ref);
    });

    return () => resizeObserver.disconnect();
  }, [data]);

  return (
    <Box
      className="featured-benefits"
      aria-labelledby="featured-benefits"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '50px',
        paddingX: '32px',
        backgroundColor: '#ddecf5'
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '1200px',
          '@media (max-width: 900px)': {
            maxWidth: '704px'
          },
          '@media (max-width: 600px)': {
            maxWidth: '344px'
          }
        }}
      >
        <Typography
          variant="h2"
          className="title"
          id="benefits-feature-title"
          sx={{ fontSize: '28px', fontWeight: '600' }}
        >
          {data.title}
        </Typography>
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: 'center'
          }}
        >
          {data.sections.map((section, index) => (
            <Grid item className="column" key={index} xs={12} sm={6} lg={4}>
              <Box
                className="container-image"
                sx={{
                  height: '200px',
                  overflow: 'hidden',
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                  '@media (max-width: 1200px)': {
                    height: '300px'
                  },
                  '@media (max-width: 900px)': {
                    height: '230px'
                  },
                  '@media (max-width: 600px)': {
                    height: '250px'
                  }
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '15px',
                    '@media (max-width: 1200px)': {
                      top: '25px'
                    },
                    '@media (max-width: 900px)': {
                      top: '20px'
                    },
                    '@media (max-width: 600px)': {
                      top: '25px'
                    },
                    width: '100%',
                    height: '100%'
                  }}
                >
                  <img
                    src={columnImageUrls[index]}
                    alt=""
                    width={'100%'}
                    style={{
                      height: '100%',
                      // objectFit: "contain",
                    }}
                  />
                </Box>
              </Box>
              <Box position={'relative'}>
                <Box
                  className="benefits-bg"
                  sx={{
                    backgroundColor: 'white',
                    width: '100vw',
                    marginLeft: 'calc(-50vw + 50%)',
                    marginRight: 'calc(-50vw + 50%)',
                    paddingLeft: 'calc(50vw - 50%)',
                    paddingRight: 'calc(50vw - 50%)',
                    zIndex: -10,
                    height: `${maxHeight}px`,
                    '@media (max-width: 1200px)': {
                      height:
                        data.sections.length - 1 === index
                          ? `${itemHeights[index]}px`
                          : `${maxHeight}px`
                    },
                    '@media (max-width: 600px)': {
                      height: `${itemHeights[index]}px`
                    }
                  }}
                ></Box>
                <Box
                  className="container-item"
                  ref={(el: HTMLDivElement | null) =>
                    (columnRefs.current[index] = el)
                  }
                  sx={{
                    paddingTop: '40px',
                    position: 'absolute',
                    top: '0',
                    zIndex: 2
                  }}
                >
                  <Typography
                    component= "h3"
                    className="item-title"
                    sx={{
                      fontSize: '20px',
                      fontStyle: 'normal',
                      fontWeight: 600,
                      lineHeight: '26px'
                    }}
                  >
                    {section.title}
                  </Typography>
                  <Typography
                    className="item-text"
                    onClick={handleAnchorClick}
                    sx={{
                      fontSize: '12px',
                      fontStyle: 'normal',
                      fontWeight: 400
                    }}
                  >
                    {section?.list.map((listItem) => (
                      <div
                        key={`ben0-${listItem.id}`}
                        dangerouslySetInnerHTML={{ __html: listItem.item }}
                      ></div>
                    ))}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
export default FeaturedBenefits;
